"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartZSpaceBase = void 0;
const Entities_1 = require("../../Entities");
class StartZSpaceBase extends Entities_1.RequestHandler {
    constructor(handler) {
        super();
        this.requestType = 'START_ZSPACE';
        this.payloadVersion = 1;
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version) => {
            if (version === this.payloadVersion) {
                this.action();
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        handler.registerRequestHandler(this);
    }
}
exports.StartZSpaceBase = StartZSpaceBase;
